module.exports = __webpack_public_path__ + "static/media/select-organization-welcome-teacher.a7ee0bbf.svg";